import { ShieldCheck, Link2, Eye } from "lucide-react";
import { SectionLabel } from "./HowItWorks";

export default function Vrf() {
  return (
    <section id="vrf" className="relative py-24 md:py-32 px-6 md:px-12" data-testid="vrf-section">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex"><SectionLabel>Provably Fair</SectionLabel></div>
          <h2
            className="font-display font-black text-4xl md:text-6xl tracking-tighter mt-5 mb-6"
            data-testid="vrf-headline"
          >
            We can't <span className="crimson-text">cheat.</span><br />Neither can anyone else.
          </h2>
          <p className="text-white/55 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            Every winner is selected by Switchboard VRF — verifiable randomness generated by
            Solana's native oracle network. The team has zero control over the outcome. You
            can audit the request, the proof, and the SOL transfer on-chain.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Trust
            icon={ShieldCheck}
            title="Cryptographic proof"
            desc="Every random number ships with a proof verifiable on-chain — no trust required."
          />
          <Trust
            icon={Link2}
            title="Oracle-secured"
            desc="Backed by Switchboard, Solana's native oracle network for on-chain randomness."
          />
          <Trust
            icon={Eye}
            title="Open audit"
            desc="The contract source, every spin, every payout — public and indexed forever."
          />
        </div>
      </div>
    </section>
  );
}

function Trust({ icon: Icon, title, desc }) {
  return (
    <div
      className="group bg-obsidian-900/40 border border-white/10 rounded-sm p-6 md:p-7 hover:border-gold/40 transition-colors"
      data-testid="vrf-trust-card"
    >
      <div className="w-11 h-11 rounded-sm border border-white/10 bg-obsidian-900/60 flex items-center justify-center mb-5 group-hover:border-gold/50 transition-colors">
        <Icon className="w-5 h-5 text-gold" />
      </div>
      <div className="font-display font-bold text-lg mb-1.5">{title}</div>
      <div className="text-sm text-white/55 leading-relaxed">{desc}</div>
    </div>
  );
}
